import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Whether a stakeholder is a formal or potential change champion / advocate',
    name: 'Stakeholder Change Champion',
    partialId: PartialId.Standard.create('stakeholder_change_champion'),
  },
  type: core.quiver.Resource.Type.DmsEnum,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnum>
